const actionTypes = require('../constants/actionTypes');
const { Promise } = require('es6-promise');
const notification = require('actions/notifications');
const apiURLBuilder = require('core/apiURLBuilder');
const { formatText } = require('core/i18n').i18n;
const { APIPost } = require('utilities/APIRequestHelper');
const { FILTERS_INVALID, FILTERS_VALID, REQUESTED_LIST_CARDS } = require('constants/index');

function requestCardAlias(alias, cardId) {
    return {
        type: actionTypes.SET_CARD_ALIAS_REQUEST,
        payload: {
            cardId,
            alias
        }
    };
}

function setCardAliasSuccess(alias, cardId) {
    return {
        type: actionTypes.SET_CARD_ALIAS_SUCCESS,
        payload: {
            cardId,
            alias
        }
    };
}

function setCardAliasFailure(cardId) {
    return {
        type: actionTypes.SET_CARD_ALIAS_FAILURE,
        payload: {
            cardId
        }
    };
}

function setCardAlias(dispatch, getState, cardId, newAlias) {
    dispatch( requestCardAlias(newAlias, cardId) );
    return new Promise(function () {
        const cards = getState().cards;
        const card = cards.get('byId').get(cardId);

        const alias = card.getIn(['alias', 'current']);
        const validFilter = card.getIn(['filters', 'valid']) ? FILTERS_VALID : FILTERS_INVALID;
        const cardRequestData = {
            query: {
                listaSolicitada: REQUESTED_LIST_CARDS,
                listaTarjetas: {
                    tarjetas: [{
                        descripcion: alias,
                        descripcionPersonalizada: newAlias,
                        filtroValido: validFilter,
                        filtroValidoPersonalizado: validFilter,
                        pan: card.get('number')
                    }]
                }
            }
        };

        APIPost(dispatch, apiURLBuilder.getURL('setCustomProfileEditSettings', {id: cardId}) , cardRequestData)
            .then(function() {
                const message = formatText('cardsTransactions-editAliasSuccess');
                dispatch(notification.success({message}, {voice: message}));
                dispatch(setCardAliasSuccess(newAlias, cardId));
            },
            function() {
                const message = formatText('cardsTransactions-editAliasError');
                dispatch(notification.error({message}, {voice: message}));
                dispatch(setCardAliasFailure(cardId));
            }
        );
    });
}

function postCardAlias(cardId, alias) {
    return function(dispatch, getState) {
        setCardAlias(dispatch, getState, cardId, alias);
    }
}

module.exports = {
  postCardAlias
}
